import { followingSidebar } from '../utils/sidebar.utils.js';

const aboutSectorSection = document.querySelector('.about-sector-sec');

if (aboutSectorSection) {
    const desktopBreakpoint = 769;
    const sidebar = aboutSectorSection.querySelector('.about-sector-sec__content');
    const contentSticky = aboutSectorSection.querySelector('.about-sector-sec__wrap');

    if (sidebar && contentSticky && window.innerWidth >= desktopBreakpoint) {
        followingSidebar({
            sidebar,
            contentSticky,
            isHeaderCalc: true,
            gap: 10,
            bottomGap: 40,
            directionThreshold: 8,
        });
    }
}
